import { SpecificEventMap } from 'events/lib'
import { useEvent } from 'events/useEvent'

// This can be used in the future for more specificity in event tracking, etc
export enum DrawerCloseReason {
  BackdropClick = 'backdropClick',
  EscapeKey = 'escapeKey',
  CloseButton = 'closeButton'
}

export const useDrawerCloseEvent = <T extends keyof SpecificEventMap>({
  ns,
  elementId,
  onClose
}: {
  ns?: T,
  elementId?: keyof SpecificEventMap[T],
  onClose?: (reason: DrawerCloseReason) => void
}) => {
  const { fireEvent: closeEvent } = useEvent(ns)
  const handleClose = (reason: DrawerCloseReason) => {
    if (elementId) {
      closeEvent(elementId)
    }
    if (onClose) {
      onClose(reason)
    }
  }

  return (reason: DrawerCloseReason) => () => handleClose(reason)
}

export default useDrawerCloseEvent
